import useDynamicPage from "@/hooks/useDynamicPage";
import { DynamicPageSeo } from "@/ui/DynamicPageSeo";
import { ContentBlocks } from "@/ui/ContentBlocks";
import { PoweredByBannerOffset } from "@/components/PoweredByBanner";

export default function Homepage({ prefix, title, seo, canonical, data }) {
  return (
    <>
      <DynamicPageSeo
        title={seo?.title || title}
        description={seo?.description || ""}
        canonical={seo?.canonical || canonical}
        keywords={seo?.keywords || ""}
        robots={seo?.robots || ""}
        json_schema={seo?.json_schema || ""}
        image={seo?.open_graph?.image?.url || ""}
      />
      <PoweredByBannerOffset />
      <ContentBlocks data={data} prefix={prefix} />
    </>
  );
}

export async function getStaticProps() {
  const page = useDynamicPage("/");

  return {
    props: {
      isBuilder: true,
      prefix: `page_homepage`,
      title: page.title,
      seo: page.seo,
      canonical: `/`,
      data: page.content,
    },
  };
}
